export default "__VITE_ASSET__D08qm3ON__"